import { useState } from "react";
import { useLookupMetasQuery } from "../../stores/OkOkStore";
import type { Metas } from "../../types/Metas";
import Pager from "../Common/Pager";
import { NavLink } from "react-router";
import { useTrads } from "../../contexts/trads/useTrads";

function MetasList(){
    const [params,setParams]=useState<Record<string, string>>({page:"0"});
    const { data, error, isLoading } = useLookupMetasQuery(params);
    const {translate}=useTrads();

    const setPage=function(page:number){
        setParams({...params,page: page.toString()})
    }

        return (
 
            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>
            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                <table className="table">
                <thead>
                    <tr>
                        <th>Nom</th>
                        <th>Explication</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {data.data.map((meta:Metas) => (

                        <tr key={meta.id}>
                            <td>{meta.name}</td>
                            <td>{meta.explication}</td>
                            
                            <td>
                                <NavLink to={`/metas/${meta.id.toString()}`}>
                                    <span className="visually-hidden">{translate('btn_voir')}</span>
                                    <i className="bi bi-eye-fill"></i>
                                </NavLink>
                            </td>
                            <td>
                                <NavLink to={`/metas/${meta.id.toString()}/edit`}>
                                    <span className="visually-hidden">{translate('btn_edit')}</span>
                                    <i className="bi bi-pencil-fill"></i>
                                </NavLink>
                            </td>    
                        </tr>

                    ))}

                </tbody>
                </table>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                
                </>
            ):null
        );
}
export default MetasList;